import { render, staticRenderFns } from "./matching-consulting.vue?vue&type=template&id=08d1f428&"
import script from "./matching-consulting.vue?vue&type=script&lang=js&"
export * from "./matching-consulting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports